if (!customElements.get("product-form")) {
  customElements.define(
    "product-form",
    class ProductForm extends HTMLElement {
      constructor() {
        super();
        this.form = this.querySelector("form");
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton?.querySelector("span");
        this.hideErrors = this.dataset.hideErrors === "true";

        if (this.variantIdInput) this.variantIdInput.disabled = false;
        this.form?.addEventListener("submit", this.onSubmitHandler.bind(this));
      }

      onSubmitHandler(event) {
        if (this.submitButton?.getAttribute("aria-disabled") === "true") {
          event.preventDefault();
          return;
        }

        if (!this.variantIdInput?.value) {
          event.preventDefault();
          this.handleErrorMessage("Selecciona una opción antes de continuar.");
          return;
        }

        this.handleErrorMessage();
        this.submitButton?.setAttribute("aria-disabled", "true");
        this.submitButton?.classList.add("loading");
        this.querySelector(".loading__spinner")?.classList.remove("hidden");
        this.variantIdInput.disabled = false;
        // Keep Shopify's native form submission. It works even if a cart drawer
        // or a third-party app fails, and Shopify redirects to the cart itself.
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;
        this.errorMessageWrapper =
          this.errorMessageWrapper ||
          this.querySelector(".product-form__error-message-wrapper");
        if (!this.errorMessageWrapper) return;
        this.errorMessage =
          this.errorMessage ||
          this.errorMessageWrapper.querySelector(".product-form__error-message");
        this.errorMessageWrapper.toggleAttribute("hidden", !errorMessage);
        if (errorMessage && this.errorMessage) this.errorMessage.textContent = errorMessage;
      }

      toggleSubmitButton(disable = true, text) {
        if (!this.submitButton) return;
        if (disable) {
          this.submitButton.setAttribute("disabled", "disabled");
          if (text && this.submitButtonText) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute("disabled");
          if (this.submitButtonText)
            this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      get variantIdInput() {
        return this.form?.querySelector('[name="id"]');
      }
    }
  );
}
